/*******************************************************************************
SWITCH TO TAB
Switch the active filter tab.
*******************************************************************************/

import getTabSettings from './get-tab-settings';
import performActions from './perform-actions';
import activateCloudinaryImages from '../cloudinary/activate';

export default function switchTab(tabSetName, tabName) {
    // Find the set of tabs to use
    const $tabs = $(`.toggle-tabs[data-name="${tabSetName}"]`);

    // If the tab set is hidden, don't do anything
    if ($tabs.parents('.toggle-tabs-set').hasClass('hide') && !$tabs.data('alwaysop')) { return; }

    // Find the tab that was clicked on
    const $tabToSelect = $tabs.find(`.toggle-tab[data-name="${tabName}"]`);

    // Add the selected class to the tab and remove it everywhere else
    $tabToSelect.addClass('is-selected').siblings('.toggle-tab').removeClass('is-selected');

    // Get all the settings for this specific tab
    const tabSettings = getTabSettings(tabSetName, tabName);

    // Perform the actions associated with the active tab
    performActions(tabSettings);

    // Trigger a custom event that signals the tab is loaded
    $(document).trigger(`toggleTabLoaded:${tabSetName}-${tabName.replace(/ /g, '-')}`, [tabSettings]);

    // Activate any Cloudinary images that may have been hidden previously
    activateCloudinaryImages();
}
